export default __webpack_public_path__ + "static/hero-join-support-545d091898fd9a954d09c20daacdfbaa.jpg";